import { useMemo, useState, type ReactNode } from 'react'
import { DeferredReviewContext } from './deferredReviewContext'

/** In-memory review markers live above both list and detail routes; a reload drops them. */
export function DeferredReviewProvider({ children }: { children: ReactNode }) {
  const [deferred, setDeferred] = useState<ReadonlySet<string>>(() => new Set())
  const value = useMemo(
    () => ({
      deferred,
      defer: (key: string) => setDeferred((previous) => new Set([...previous, key])),
    }),
    [deferred]
  )
  return <DeferredReviewContext.Provider value={value}>{children}</DeferredReviewContext.Provider>
}
